import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Weights in kg per square meter (kg/m2)
const GLASS_TYPES = [
    { id: '4mm', name: '4 מ"מ שקוף / חלבי', weightPerSqm: 10 },
    { id: '5mm', name: '5 מ"מ שקוף / זכוכית רשת', weightPerSqm: 12.5 },
    { id: '6mm', name: '6 מ"מ שקוף / אנטי סאן', weightPerSqm: 15 },
    { id: '8mm', name: '8 מ"מ מחוסם', weightPerSqm: 20 },
    { id: '10mm', name: '10 מ"מ מחוסם', weightPerSqm: 25 },
    { id: 'triplex33', name: '3+3 טריפלקס שקוף (ביטחון)', weightPerSqm: 15 },
    { id: 'triplex33white', name: '3+3 טריפלקס חלבי (ביטחון)', weightPerSqm: 15 },
    { id: 'triplex33gray', name: '3+3 טריפלקס אפור (ביטחון)', weightPerSqm: 15 },
    { id: 'triplex44', name: '4+4 טריפלקס שקוף', weightPerSqm: 20 },
    { id: 'triplex44white', name: '4+4 טריפלקס חלבי', weightPerSqm: 20 },
    { id: 'triplex44gray', name: '4+4 טריפלקס אפור', weightPerSqm: 20 },
    { id: 'triplex55', name: '5+5 טריפלקס', weightPerSqm: 25 },
    { id: 'bidudit4124', name: '4-12-4 בידודית', weightPerSqm: 20 }, // Weight is based on 8mm total glass
    { id: 'bidudit6126', name: '6-12-6 בידודית', weightPerSqm: 30 },
    { id: 'bidudit44_12_4', name: 'טריפלקס 4+4 - 12 - 4 (בידודית חכמה)', weightPerSqm: 30 },
];

export default function GlassWeightCalculator() {
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [glassType, setGlassType] = useState('4mm');

    const W = parseFloat(width) || 0;
    const H = parseFloat(height) || 0;

    let totalWeight = 0;
    let squareMeters = 0;

    if (W > 0 && H > 0) {
        squareMeters = (W / 1000) * (H / 1000);
        const selectedGlass = GLASS_TYPES.find(g => g.id === glassType);
        if (selectedGlass) {
            totalWeight = squareMeters * selectedGlass.weightPerSqm;
        }
    }

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded-xl shadow-lg mt-10" dir="rtl">
            <Link to="/professionals" className="inline-flex items-center gap-2 text-gray-500 hover:text-blue-700 mb-4 transition-colors font-bold">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                חזרה למחשבונים
            </Link>
            <div className="flex items-center gap-4 mb-6 border-b pb-4">
                <img src="/assets/logo-circle.png" alt="Alum Nawatha" className="w-16 h-16 object-contain" onError={(e) => { e.target.style.display = 'none'; }} />
                <h2 className="text-3xl font-bold text-blue-900">מחשבון משקל זכוכית</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div>
                    <label className="block text-gray-700 font-bold mb-2">רוחב זכוכית (מ"מ):</label>
                    <input type="number" value={width} onChange={(e) => setWidth(e.target.value)} className="border-2 border-blue-200 p-3 rounded-lg w-full text-lg outline-none" placeholder="לדוגמה: 800" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">גובה זכוכית (מ"מ):</label>
                    <input type="number" value={height} onChange={(e) => setHeight(e.target.value)} className="border-2 border-blue-200 p-3 rounded-lg w-full text-lg outline-none" placeholder="לדוגמה: 1200" />
                </div>
                <div>
                    <label className="block text-gray-700 font-bold mb-2">סוג זכוכית:</label>
                    <select value={glassType} onChange={(e) => setGlassType(e.target.value)} className="border-2 border-blue-200 p-3 rounded-lg w-full text-lg outline-none cursor-pointer bg-white">
                        {GLASS_TYPES.map(g => (
                            <option key={g.id} value={g.id}>{g.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {totalWeight > 0 && (
                <div className="bg-blue-50 border border-blue-200 p-6 rounded-lg text-center">
                    <p className="text-gray-600 mb-2">שטח הזכוכית: {squareMeters.toFixed(2)} מ"ר</p>
                    <h3 className="text-2xl font-bold text-blue-900 mb-2">משקל נטו:</h3>
                    <div className="text-5xl font-mono font-bold text-blue-600">
                        {totalWeight.toFixed(1)} <span className="text-2xl text-gray-500">ק"ג</span>
                    </div>
                    {totalWeight > 50 && (
                        <div className="mt-4 p-3 bg-yellow-100 text-yellow-800 rounded-md font-bold">
                            ⚠️ שים לב: משקל מעל 50 ק"ג! נדרשים לפחות 2 פועלים ו/או פטמות ואקום להנפה.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
